var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9242 12.3069C41.6256 15.1032 49.536 19.9319 55.999 26.3943C52.899 31.4716 48.7102 35.5996 44.3545 37.8688C39.9989 40.1379 35.8328 40.3627 32.773 38.4945C29.7132 36.6263 28.0098 32.8178 28.0382 27.9066C28.0666 22.9955 29.8244 17.3841 32.9242 12.3069ZM37.0305 31.5216C35.8537 30.8031 34.5376 30.4217 33.3716 30.4604C32.2057 30.4992 31.2851 30.9546 30.8129 31.7278C34.3247 32.4123 37.4743 34.3354 39.6878 37.1465C40.1597 36.3733 40.1449 35.3465 39.6469 34.2919C39.1486 33.237 38.2073 32.2401 37.0305 31.5216ZM37.1883 21.001C35.8581 20.1889 34.1212 20.6089 33.3088 21.939C32.4966 23.2693 32.9167 25.0062 34.2469 25.8185C35.5773 26.6308 37.3141 26.2108 38.1264 24.8804C38.9385 23.5501 38.5186 21.8132 37.1883 21.001ZM46.4714 26.321C45.1411 25.5088 43.4042 25.9289 42.5919 27.2591C41.7796 28.5894 42.1996 30.3263 43.53 31.1386C44.8603 31.9508 46.5972 31.5309 47.4094 30.2005C48.2215 28.8702 47.8017 27.1332 46.4714 26.321Z",
    fill: "url(#paint0_linear_2149_9618)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.766532 14.4949C8.72595 8.09564 18.096 3.68499 28.0996 1.62853C30.9307 7.64288 32.2053 14.0888 31.6442 19.548C31.0832 25.0072 28.7321 29.0333 25.1075 30.7395C21.483 32.4455 16.8818 31.692 12.3171 28.6457C7.75243 25.5993 3.59757 20.5091 0.766532 14.4949ZM26.4755 20.0048C23.6773 22.8605 19.9467 24.6166 15.9628 24.9533C16.394 25.8694 17.3622 26.4877 18.6529 26.6714C19.9434 26.8551 21.4515 26.5899 22.8454 25.9338C24.2394 25.2776 25.4055 24.2841 26.0863 23.1724C26.7671 22.0606 26.9067 20.9209 26.4755 20.0048ZM11.5013 15.8628C9.9255 16.6046 9.24883 18.4834 9.99034 20.0592C10.7322 21.6352 12.6118 22.3116 14.1877 21.5698C15.7633 20.8278 16.439 18.9486 15.6973 17.3729C14.9554 15.7974 13.077 15.1214 11.5013 15.8628ZM22.1721 10.4728C20.5963 11.2147 19.9207 13.0939 20.6624 14.6697C21.4042 16.2455 23.2826 16.9214 24.8585 16.1798C26.4343 15.438 27.1112 13.5592 26.3694 11.9834C25.6276 10.4074 23.748 9.73102 22.1721 10.4728Z",
    fill: "url(#paint1_linear_2149_9618)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_9618",
    x1: 45.301,
    y1: 17.9758,
    x2: 32.7731,
    y2: 38.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2149_9618",
    x1: 13.6666,
    y1: 6.43328,
    x2: 25.108,
    y2: 30.7394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECBF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAct);
export default __webpack_public_path__ + "static/media/act.89089d7cba300f14a318e57e63da3f6e.svg";
export { ForwardRef as ReactComponent };